// The Individual Marketplace's header information needs to displayed and it may
// be either of a community host or a distribution location.
import React from "react";
import { Link } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import OrderCutoffPopover from "./OrderCutoffPopover.jsx";
import DeliveryChargePopover from "./DeliveryChargePopover.jsx";
import CalcHubStats from "../../../functions/CalcHubStats.js";

export default function IndMarketplaceHeaderInformation({
  userInfo,
  currentStatus,
  farmDetails,
  productDownload,
}) {
  // Set the variables for the hub.
  const [
    deliveryFee,
    baseDeliveryFee,
    minDeliveryFee,
    communityLocation,
    distributionLocation,
    orderCutoffDate,
    pickupDate,
    address,
    orderCutoff,
    pickupDay,
    pickupTime,
    subsidyAmount,
  ] = CalcHubStats(userInfo, currentStatus);

  // If the user has selected a pickupLocation
  if (userInfo.pickupLocation !== undefined) {
    return (
      <Grid
        container
        className="Marketplace-Grid-Header"
        style={{
          marginTop: "10px",
          marginBottom: "20px",
          alignItems: "baseline",
        }}
      >
        <Grid item xs>
          <h1 className="Title-Marketplace">Marketplace</h1>
        </Grid>
        <Grid item xs>
          <div className="Location-Title-And-Details">
            <span
              style={{
                display: "flex",
                alignItems: "baseline",
                minWidth: "400px",
              }}
            >
              {userInfo.pickupLocation.pickupLocation !== undefined ? (
                <div className="Community-Title-And-Distribution-Location">
                  <h1 className="Pickup-Location-Title">
                    {communityLocation.locationName}
                  </h1>
                  <p style={{ margin: "-10px 0px 0.5em 0px" }}>
                    Delivered through :{" "}
                    {distributionLocation.displayName ||
                      distributionLocation.name}
                  </p>
                </div>
              ) : (
                <h1 className="Pickup-Location-Title">
                  {userInfo.pickupLocation.displayName ||
                    userInfo.pickupLocation.name}
                </h1>
              )}

              <Link
                to={{
                  pathname: "/DistributionLocationSelection",
                  query: "/Marketplace",
                }}
              >
                <Button color="primary">CHANGE</Button>
              </Link>
            </span>

            <span className="Distribution-Location-Details">
              <p style={{ margin: "0px" }}>
                <b>Address :</b> {address}
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  right: "31px",
                }}
              >
                <OrderCutoffPopover farmDetails={farmDetails} />
                <p style={{ margin: "5px 0px" }}>
                  <b>Order Cutoff :</b> {orderCutoff}, {orderCutoffDate}
                </p>
              </div>
              <p style={{ margin: "0px" }}>
                <b>Pickup Time :</b> {pickupDay} {pickupTime}, {pickupDate}
              </p>
              <p style={{ margin: "5px 0px" }}>
                <b>Maximum Subsidy Per Order :</b> ${subsidyAmount}
              </p>
              {userInfo.pickupLocation.pickupLocation !== undefined && (
                <>
                  {deliveryFee > 0 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        right: "31px",
                      }}
                    >
                      <DeliveryChargePopover
                        baseDeliveryFee={baseDeliveryFee.toFixed(2)}
                        minDeliveryFee={minDeliveryFee.toFixed(2)}
                      />
                      <p style={{ margin: "5px 0px" }}>
                        <b>Current Delivery Charge:</b> $
                        {deliveryFee.toFixed(2)}
                      </p>
                    </div>
                  )}
                  <p style={{ margin: "5px 0px" }}>
                    <b>Current Total Customers vs. Max Allowed:</b>{" "}
                    {currentStatus[1]}/{communityLocation.maxParticipants}
                  </p>
                </>
              )}
            </span>
            {productDownload}
          </div>
        </Grid>
      </Grid>
    );
  }
  return null;
}
